import { gql, useQuery } from "@apollo/client"
import { useLocation, useParams } from "react-router-dom"
import { useProfile } from "src/shared/hooks/useProfile"

const QUERY = gql`
    query Incidencias($matricula: String, $hotel_id: ID) {
        incidencias(matricula: $matricula, hotel_id: $hotel_id) {
            incidencia_id
            detalle
            habitacion_id
            folio
            fecha_registro
            fecha_cierre
            colaborador_id_reporta
            estado
            huesped
            tipo_incidencia
            matricula
            vehiculo {
                matricula
                modelo
            }
            colaborador_reporta {
                nombre
                apellido_paterno
                apellido_materno
                puesto {
                    nombre
                }
            }
            colaborador_id_cierra
            colaborador_cierra {
                nombre
                apellido_paterno
                apellido_materno
            }
            area
            severidad
            turno_id
            turno {
                nombre
            }
            habitacion {
                habitacion_id
                numero_habitacion
                tipo_habitacion_id
                tipo_habitacion {
                    tipo_habitacion_id
                    nombre
                }
            }
        }
    }
`

export function useFetch() {
    const params = useParams()
    const { state } = useLocation()
    const matricula = params?.matricula || ""
    const { hotel_id } = useProfile()
    

    const { loading, data, refetch } = useQuery(QUERY, { variables: { matricula, hotel_id } })
    const vehiculo = data?.incidencias?.[0]?.vehiculo
    const modelo = state?.modelo || vehiculo?.modelo || ""

    return {
        loading,
        incidencias: Array.isArray(data?.incidencias) ? [...data.incidencias] : [],
        matricula: `${modelo ? `${modelo} `  : ""}${matricula}`,
        refetch
    }
}
